import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FilterService} from '../filter.service';
import {DisplayFilter} from '../filters.component';
import {Subject} from 'rxjs';
import * as moment_ from 'moment';
import * as moment__ from 'moment-timezone';
import {MAT_MOMENT_DATE_FORMATS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateStrictAdapter} from './moment-strict-date-adapter';

const moment = moment__;
const momentMoment = moment_;

export const MY_FORMATS = {
    parse: {
        dateInput: ['M-D-YYYY', 'M/D/YYYY', 'M.D.YYYY', 'MDYYYY'],
         },
    display: MAT_MOMENT_DATE_FORMATS.display,
};


@Component({
    selector: 'copart-date-range-filter',
    templateUrl: './date-range-filter.component.html',
    styleUrls: ['./date-range-filter.component.scss'],
    providers: [
        // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
        // `MatMomentDateModule` in your applications root module. We provide it at the component level
        // here, due to limitations of our example generation script.
        {provide: DateAdapter, useClass: MomentDateStrictAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},

    ]
})
export class DateRangeFilterComponent implements OnInit, OnDestroy {

    inputFormat: string[];
    /**
     * Stores the start date for the Expiration date filter
     */
    startDate: moment_.Moment;

    /**
     * Stores the end date for the Expiration date filter
     */
    endDate: moment_.Moment;

    /**
     * Data about the filter
     */
    @Input() filterData: any;

    /**
     * event listener to listen to clear events
     */
    @Input() clearFilter: Subject<DisplayFilter>;

    /**
     * subscription handler
     */
    private clearSubscription: any;
    /**
     * Identifies if the end date is valid or not
     */
    isEndInValid: boolean;
    /**
     * Identifies if the start date is valid or not
     */
    isStartInvalid: boolean;
    /**
     * Lower limit for date selection
     */
    @Input() minDate: Date;

    @Input() translateObject;

    @Output() response = new EventEmitter();

    preferredLocale: any;
    preferredDateFormat: any;
    preferredTimeZone: any;

    /**
     * Identifies if the start date is greater than end date
     */
    invalidRange: boolean;

    isApplied: boolean;

    timepicker1 = new Date();
    timepicker2 = new Date();

    @Input() showtimeFilter: boolean = false;

    constructor(private filterService: FilterService, private adapter: DateAdapter<any>) {
        this.isEndInValid = false;
        this.isStartInvalid = false;
        this.invalidRange = false;
        this.isApplied = false;
        this.minDate = new Date(1900, 0, 1);
        this.setFilterTimeTODefault();
    }

    ngOnInit() {
      this.preferredLocale = this.translateObject.preferredLocale;
      this.preferredDateFormat = this.translateObject.preferredDateFormat;
      this.preferredTimeZone = this.translateObject.preferredTimeZone;
      this.adapter.setLocale(this.preferredLocale);
      this.clearSubscription = this.clearFilter.subscribe((filter) => {
          this.clearCustomFilter(filter);
      });
       }

    /**
     * Updates the filter data of the main filter with the values of the custom Expiration Date filter.
     */
    search() {
        if (this.startDate || this.endDate) {
            /* add the data to filter only if its populated */
            let query = this.filterData.rangeQuery;
            if (query) {
                query = query.replace('#from', this.toUtc(this.startDate, false));
                query = query.replace('#to', this.toUtc(this.endDate, true));
                query = query.replace('to', 'TO'); // TODO:Will be removed once the server changes are done
            }
            const name = this.getDate(this.startDate) + ' - ' + this.getDate(this.endDate);
            // Remove the previously applied date filter, if any and don't emit event
            // so no server call is made to fetch new data
            this.filterService.clearFilter(this.filterData, false);
            this.response.emit({filter : this.filterData, item: {code: query, name}});
        }
    }

    /**
     * Converts the date to ISO or local string format based on the flag, also returns the default string value if the
     * date value is null or undefined
     *  {Date} date : date to be converted
     *  {boolean} isISO : should be converted to ISO string  or not
     *  {string} nullString : place holder to  return if the date parameter is undefined or null
     *  {string} : converted date string
     */
    private getDate(date: moment_.Moment, isISO: boolean = true, nullString: string = '*'): string {
        if (date) {
               return  date.format(this.preferredDateFormat);
        }
        return '*';
    }

    private toUtc(date: moment_.Moment, isEnd) {

        // Please note: Datepicker returns date in local time. We do not need time zone information
        // and simply need to extract date and treat it as UTC, set time and then send back
        if (!date) {
            return '*';
        }
      const dateString = moment(date).format('YYYY-MM-DD'); // extract date
        const utcDate = moment.utc(dateString); // create UTC moment

        let time = {
            hour: (this.timepicker1 && this.timepicker1.getHours() >= 0) ? this.timepicker1.getHours() : 0,
            minute: (this.timepicker1 && this.timepicker1.getMinutes()  >= 0) ? this.timepicker1.getMinutes() : 0,
            second: 0,
            millisecond: 0
        };
        // placing this in comments as i see no importance && this.filterData.filter.rangeQuery.indexOf('_ts_utc') != -1
        if (isEnd) {
            time = {
                hour: (this.timepicker2 && this.timepicker2.getHours()  >= 0) ? this.timepicker2.getHours() : 23,
                minute: (this.timepicker2 && this.timepicker2.getMinutes()  >= 0) ? this.timepicker2.getMinutes() : 59,
                second: 59,
                millisecond: 0
            };
        }
        utcDate.set(time);
        // return utcDate.toISOString(false);
        return moment.utc(moment.tz(dateString, this.preferredTimeZone).set(time)).toISOString(false);
    }

// date.utc(true).set(time).toISOString(false)
    /**
     * Clears the custom filter fields.
     *  filter : Identifies, if the request for clearing the filter field was made to which filter.
     * if the clear request was for all the filters this field will be undefined,
     * else if the clear request was targeted for a particular filter the value stored in this variable will
     * match the filter header.
     */
    clearCustomFilter(filter) {
        if (!filter || (this.filterData && filter.code === this.filterData.code)) {
            this.clearCurrentFilter();
        }
    }

    /**
     * Clears the search fields
     */
    private clearCurrentFilter() {
        this.startDate = null;
        this.endDate = null;
        this.isEndInValid = false;
        this.isStartInvalid = false;
        this.invalidRange = false;
        this.setFilterTimeTODefault();
    }

    /**
     * Event which listens to change in the input fields
     *  isStartDate : identifies if this is the start date input
     *  event :
        **/
    validate(isStartDate, event) {
        const el = event.targetElement;
        if (event.targetElement) {
            if (isStartDate) {
                // if value is empty, its valid
                this.isStartInvalid = el.value && this.checkIfInvalid(this.startDate);
            } else {
                this.isEndInValid = el.value && this.checkIfInvalid(this.endDate);
            }
        }
        this.checkRange();
    }

    /**
     * Checks if the date is valid
     *  date
     *  {boolean}
     */
    checkIfInvalid(date) {
        // if parsed date is null then its invalid
        return date == null || moment(this.minDate).isAfter(moment(date));
    }

    /**
     * Checks if the dates are in range or not
     */
    checkRange() {
        if (!this.startDate || !this.endDate) {
            this.invalidRange = false;
        } else {
            const s = moment(this.startDate);
            this.invalidRange = s.isAfter(moment(this.endDate)); 
            if(!this.invalidRange) this.timeValidate();
        }
    }

    setFilterTimeTODefault(){
        this.timepicker1.setHours(0);
        this.timepicker1.setMinutes(0);
        this.timepicker1.setSeconds(0);
        this.timepicker2.setHours(23);
        this.timepicker2.setMinutes(59);
        this.timepicker2.setSeconds(59);
    }

    timeValidate(){
        const tp1 = moment(this.timepicker1);
        if(moment.duration(moment.utc(this.endDate).diff(moment.utc(this.startDate))).asDays() == 0){
            this.invalidRange = tp1.isAfter(moment(this.timepicker2));
        }
    }

    /**
     * release all the resources and unsubscribe.
     */
    ngOnDestroy(): void {
        this.clearSubscription.unsubscribe();
    }
}
